import React from "react";

import "./detailAside.css";
import { Link } from "react-router-dom";

const DetailAside = ({
  course_img,
  title,
  price_old,
  price_new,
  price_discount,
  features}) => {
  return (
    <aside className="course-aside box p-3">
      <div className="aside-price my-3">
        
        <span className="price-new me-3 fs-3 fw-bold">{price_new}</span>
        
      </div>
      
      <div className="aside-btn">
        <Link
          to="../../contact"
          className="theme-btn w-100"> 
          Prijavi se na kurs
        </Link>
        
      </div>
      <br></br>
      <a href = 'http://moodle.smartbasic.edu.rs/' target="_blank" rel="noopener noreferrer">Moodle link sa snimcima</a><em> (Za one koji su uplatili kurs)</em>
      
    </aside>
    
  );
};

export default DetailAside;
